App.controller('ContinueStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', '$timeout', function ($scope, $sce, $state, $http, packageService, $stateParams, $timeout) {
    $scope.stateParams = $stateParams;

    $scope.page = 'continue_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Kontynuacja Ubezpieczenia na życie w PZU Życie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.next = function () {
        $state.go('root.continue.start');
    }

    $timeout(function () {
        if (!$('.menu.menu_8').hasClass('open')) {
            $('a[target=".menu_8"]').trigger('click');
        }
    }, 0);
}]);